module.exports = __webpack_public_path__ + "static/media/author-shape2.ce349b39.png";